@if (isLoggedIn) {
	<div [class]="theTerminalClass" class="example-container">
		<mat-toolbar
			cdkOverlayOrigin
			#trigger="cdkOverlayOrigin"
			id="toolbar-main"
			[ngStyle]="{
				zIndex: isOpen || isOpenServices ? 20000 : 'auto',
				position: isOpen || isOpenServices ? 'relative' : 'static',
			}">
			@if (sidenavService.isTablet() && !sidenavService.isPhone()) {
				<mat-icon (click)="sidenavService.toggleMobileMenu()" svgIcon="acies_mobile_menu" style="min-width: 24px" id="mobile-menu"></mat-icon>
			}
			<!-- Icon and service opener -->
			<div id="logo-top-left" (click)="isOpenServices = !isOpenServices; isOpen = false" cdkOverlayOrigin (clickOutside)="hideServiceOverlay($event)" #triggerServices="cdkOverlayOrigin">
				<mat-icon svgIcon="acies_alogo"></mat-icon>
				<button id="openServicesList" class="multiline-button mat-caption" type="button">
					<span class="mat-caption"><strong>AciesCore</strong></span>
					<span class="mat-caption">Services</span>
					<div class="account-icon">
						<mat-icon svgIcon="acies_chevrondown" class="arrow-rotating" [ngClass]="{ 'arrow-rotating__opened': isOpenServices }"></mat-icon>
					</div>
				</button>
			</div>
			<!-- Service name -->
			@if (!sidenavService.isPhone()) {
				<div class="topbar-active-service">{{ selectedServiceName | translate }}</div>
			}
			<span class="example-spacer"></span>
			<!-- Help Button -->
			<button mat-icon-button (click)="helpClicked()" style="margin-right: 10px" [disableRipple]="true">
				<mat-icon svgIcon="acies_help"></mat-icon>
			</button>
			<!-- Notification -->
			@if (!sidenavService.isPhone()) {
				<button mat-icon-button (click)="notificationService.toggleNotificationCenter(); notificationService.resetUnread()" style="margin-right: 10px" [disableRipple]="true">
					<mat-icon svgIcon="acies_notification"></mat-icon>
					@if (unreadCount) {
						<span class="notification-count" [ngClass]="{ 'red-alert': unreadError }">
							{{ unreadCount }}
						</span>
					}
				</button>
			}
			<!-- Analystics button -->
			@if (sidenavService.isPhone() && selectedServiceName == 'insights.service.label') {
				<button mat-icon-button (click)="sidenavService.toggleRightPanel()" [disableRipple]="true" id="phoneReportsButton">
					<mat-icon svgIcon="acies_analytics"></mat-icon>
				</button>
			}
			<!-- Profile menu button-->
			<button mat-icon-button [matMenuTriggerFor]="profileMenu" style="margin-right: 10px" [disableRipple]="true">
				<mat-icon svgIcon="acies_user"></mat-icon>
			</button>
			<!-- Profile menu -->
			<mat-menu #profileMenu="matMenu">
				@if (isAccountAdmin) {
					<button mat-menu-item (click)="selectAciesCoreServiceByName('Administration')">
						<span>{{ 'administration.service.label' | translate }}</span>
					</button>
				}
				<button mat-menu-item [matMenuTriggerFor]="languageMenu">
					<span>{{ 'general.profile.menuitem.language.title' | translate }}</span>
				</button>
				@if (engineEnvironments.length > 1) {
					<button mat-menu-item [matMenuTriggerFor]="engineMenu">
						<span>{{ 'general.profile.menuitem.engine.title' | translate }}</span>
					</button>
				}
				<hr />
				<button mat-menu-item (click)="onLogout($event)">
					<span>{{ 'topbar.logout.logout' | translate }}</span>
				</button>
			</mat-menu>
			<!-- Profile language submenu -->
			<mat-menu #languageMenu="matMenu">
				<button mat-menu-item (click)="setLang('da')">
					<span>
						<mat-icon>{{ getChecketLanguageIcon('da') }}</mat-icon>
						{{ 'general.profile.menuitem.language.danish.title' | translate }}
					</span>
				</button>
				<button mat-menu-item (click)="setLang('en')">
					<span>
						<mat-icon>{{ getChecketLanguageIcon('en') }}</mat-icon>
						{{ 'general.profile.menuitem.language.english.title' | translate }}
					</span>
				</button>
				<button mat-menu-item (click)="setLang('reset')">
					<span>
						<mat-icon></mat-icon>
						{{ 'general.profile.menuitem.language.reset.title' | translate }}
					</span>
				</button>
			</mat-menu>
			<!-- Profile engine submenu -->
			<mat-menu #engineMenu="matMenu">
				@for (environment of engineEnvironments; track environment.environmentId + ':' + environment.engineId) {
					<button mat-menu-item (click)="selectEngineEnvironment(environment)">
						<span>
							<mat-icon>{{ getCheckedEnvironmentIcon(environment) }}</mat-icon>
							{{ environment.name }}
						</span>
					</button>
				}
			</mat-menu>
			@if (!sidenavService.isPhone()) {
				<div class="user-account-info">
					<div class="mat-caption">{{ userEmail }}</div>
					<div class="mat-caption">{{ userAccount }}</div>
				</div>
			}

			@if (hasSuperadminPermission) {
				<button mat-icon-button [disableRipple]="true" (click)="selectAciesCoreServiceByName('Setup')">
					<mat-icon svgIcon="acies_configs"></mat-icon>
				</button>
			}
			<button mat-icon-button (click)="isOpen = !isOpen; isOpenServices = false; setSearchFocus()" [disableRipple]="true">
				<mat-icon svgIcon="acies_organization"></mat-icon>
			</button>
		</mat-toolbar>
		<ng-template
			cdkConnectedOverlay
			[cdkConnectedOverlayOrigin]="trigger"
			[cdkConnectedOverlayOpen]="isOpen"
			[cdkConnectedOverlayPositions]="overlayOptions.positions"
			[cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop-cs'"
			[cdkConnectedOverlayHasBackdrop]="true"
			[cdkConnectedOverlayHeight]="scrHeight"
			(backdropClick)="hideOverlay($event)"
			[cdkConnectedOverlayMinWidth]="sidenavService.isPhone() ? scrWidth : 0"
			[cdkConnectedOverlayFlexibleDimensions]="sidenavService.isPhone()">
			<div [ngClass]="sidenavService.isPhone() ? 'pwa-account-list' : 'example-list'">
				<div class="account-header very-dark-header" style="font-size: 16px; font-weight: bold">
					{{ 'topbar.account.select' | translate }}
				</div>
				<mat-form-field appearance="outline">
					<input matInput autofocus placeholder="{{ 'topbar.account.filter' | translate }}" [formControl]="filter" (keyup)="onKeydown($event)" id="accountSearch" autocomplete="off" #accountSearch />
					<button mat-icon-button matPrefix>
						<mat-icon svgIcon="acies_search"></mat-icon>
					</button>
				</mat-form-field>
				<mat-selection-list [multiple]="false" id="selectAccount" [hideSingleSelectionIndicator]="true">
					@if (accountsLoading) {
						<div id="accountlist-loading">
							<img class="spinner" src="./assets/spinner.gif" />
						</div>
					}
					@if (true) {
						<div [ngStyle]="{ maxHeight: scrHeight - 211 + 'px' }">
							@for (organization of dataFiltered$ | async; track organization) {
								<div class="organization-wrap">
									<div class="mat-subtitle-2 white-header level2-header" style="font-size: 14px">
										<mat-icon svgIcon="acies_organization" style="height: 30px; overflow: visible"></mat-icon>
										{{ organization.organization.name }}
									</div>
									@for (account of organization.accounts; track account) {
										<app-account-list-item [item]="account" (selected)="selectAccount($event)"></app-account-list-item>
									}
								</div>
							}
						</div>
					}
				</mat-selection-list>
			</div>
		</ng-template>
		<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerServices" [cdkConnectedOverlayOpen]="isOpenServices" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop-cs'" [cdkConnectedOverlayHasBackdrop]="true">
			<mat-selection-list [hideSingleSelectionIndicator]="true" #list class="service-list" [multiple]="false" (selectionChange)="serviceListSelectionChanged($event)">
				<div class="very-dark-header" style="padding-left: 16px; font-size: 16px; font-weight: bold">
					{{ 'topbar.service.select' | translate }}
				</div>
				@for (service of services | customFilter: filtercond; track service) {
					<mat-list-option class="service-list-item service-selected" [value]="service">
						<span matListItemTitle>
							{{ (service.forceTranslateKey ? service.forceTranslateKey : service.label.toLowerCase()) | translate }}
						</span>
					</mat-list-option>
				}
			</mat-selection-list>
		</ng-template>
	</div>
}

<app-notificationcenter [visible]="notificationService.notificationCenterVisible$ | async"></app-notificationcenter>
<app-floatingitems></app-floatingitems>
